import React from "react";
import CommonDefaultQuestionEdit from "./CommonDefaultQuestionEdit";

function QuestionMultipleChoiceEdit(props) {

    return (<CommonDefaultQuestionEdit {...props}/>);
}

export default QuestionMultipleChoiceEdit;